// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1VC87","logo":"Header_logo__3_SJs","title":"Header_title__3SH2Q"};